import {JournalsCardSection} from './JournalsCardSection';
export default JournalsCardSection;
